import { type RouteRecordRaw } from 'vue-router';

import { noAccessPageRoute } from '@/pages/no-access/routes';

import NoAuthLayout from './noauth-layout.vue';

export const noAuthSubRoutes: RouteRecordRaw[] = [noAccessPageRoute];

export const noauthRoute: RouteRecordRaw = {
    path: '/noauth',
    component: NoAuthLayout,
    children: noAuthSubRoutes
};
